module.exports = __webpack_public_path__ + "img/new-file.db6b91cf.svg";